@import (reference) '../../../constants/spacing.module.less';

.rate-list {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
  padding: @space-16;
  flex: 1;
}

.loading-indicator-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  gap: @space-8;
  flex: 1;
}

.loading-indicator {
  height: 90px;
  width: 90px;
}

.loading-indicator-icon {
  width: 50px;
  height: 50px;
}

.empty-message {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  gap: @space-8;
  text-align: center;
  flex: 1;
}

.wallet-activation-button {
  margin-top: @space-8;
}
